export const stDesk = {
  containButton: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    margin: '0px 7px',
    border: 'none',
    borderRadius: '7px',
    padding: '5px 7px',
    boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.2), -4px -4px 8px rgba(255, 255, 255, 0.2)',

    '&:hover': {
      transform: 'scale(0.95)',
    },
  },
  containSelectedBtt: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: 'auto',
  },
  iconBtt: {
    minHeight: '20px',
    minWidth: '20px',
  },
  containCentral: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  labelBtt: {
    color: 'black',
    fontFamily: 'jost-light',
    fontWeight: 'bold',
    fontSize: '14px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  containCentralInferior: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
  },
  containIcons: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: 'auto',
    marginLeft: '8px',
  },
  containNobre: {
    backgroundColor: 'gold.fadedGold',
    color: 'gold.main',
    fontWeight: 'bold',
    padding: '3px',
    borderRadius: '50%',
    height: 'auto',
    width: 'auto',
  },
  containPromocao: {
    backgroundColor: 'success.lightGreen',
    color: 'success.green',
    fontWeight: 'bold',
    padding: '3px',
    borderRadius: '50%',
    height: 'auto',
    width: 'auto',
  },
}

export const stMob = {
  colorSolicitado: {
    color: 'var(--color-text-hig)',
    fontWeight: 'bold',
  },
}
